function MainContent() {
  return (
    <div className='pagecontent'>
            <div className='pagesection'>
              <div className='sectioncol reveal'>
                <h1>Who we are</h1>
              </div>
              <div className='sectioncol reveal'>
                <p>Blue Coast Capital is a privately owned group of businesses with its origins in post-war UK retailing. With a track-record spanning 50 years, Blue Coast now owns and manages a diverse global portfolio of private and public assets.</p>
              </div>
            </div>
            <div className='pagesection'>
              <div className='sectioncol reveal'>
                <h1>How we invest</h1>
              </div>
              <div className='sectioncol reveal'>
                <p>Blue Coast Capital has the experience and financial strength to make investment decisions on long term trends as well as unique short-term opportunities.</p>

                <p>BCCAP’s key business areas are Real Estate, Hotels and Consumer but it invests in a broad range of asset classes both directly and indirectly.</p>
              </div>
            </div>
          </div>
  );
}

export default MainContent;
